export default [
  {
      value: "ContratoLicenca",
      text: "Contratos de Licença"
  },
]